export const getEventColor = situationId => {
  if(+situationId == 1) {
    return '#757575';
  }

  if(+situationId == 2) {
    return '#022A5C';
  }

  if(+situationId == 3) {
    return '#F5B941';
  }

  if(+situationId == 4) {
    return '#FF863A';
  }

  if(+situationId == 5) {
    return '#F66C6B';
  }

  if(+situationId == 6) {
    return '#13BC4B';
  }

  return '#757575';
}

export const situationOptions = [
  { label: 'Pendente', value: '1', color: getEventColor(1) },
  { label: 'Confirmado', value: '2', color: getEventColor(2) },
  { label: 'Iniciado', value: '3', color: getEventColor(3) },
  { label: 'Atrasado', value: '4', color: getEventColor(4) },
  { label: 'Concluído', value: '6', color: getEventColor(6) }
];

export const appointmentTypeOptions = [
  { label: 'Serviço', value: '1' },
  { label: 'Outros', value: '2' }
];